import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SchoolYear } from '@td/shared';
import { get, post } from '../lib/api';

const KEY = ['school-years'];

export function useSchoolYears() {
  return useQuery({ queryKey: KEY, queryFn: () => get<SchoolYear[]>('/school-year') });
}

/** Everything a roll-over touches has to be refetched afterwards. */
function useAfterRollOver() {
  const qc = useQueryClient();

  return () => {
    void qc.invalidateQueries({ queryKey: KEY });
    void qc.invalidateQueries({ queryKey: ['students'] });
    void qc.invalidateQueries({ queryKey: ['assessments'] });
    void qc.invalidateQueries({ queryKey: ['seating'] });
    void qc.invalidateQueries({ queryKey: ['dashboard'] });
    void qc.invalidateQueries({ queryKey: ['auth', 'me'] });
  };
}

export function useArchiveSchoolYear() {
  const after = useAfterRollOver();
  return useMutation({
    mutationFn: () => post<{ archived: SchoolYear | null }>('/school-year/archive', {}),
    onSuccess: after,
  });
}

export function useRestoreSchoolYear() {
  const after = useAfterRollOver();
  return useMutation({
    mutationFn: (id: string) => post(`/school-year/${id}/restore`, {}),
    onSuccess: after,
  });
}
